export default __webpack_public_path__ + "static/media/Vera - 3679.62d7cab8.jpeg";